import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateRedirectUrl } from '@domain-group/javascript-utils'

import { generateUrls, useRelations } from '@hooks/useAgency'

import type { AgencyModel } from '@domain-group/realhub-backend-api-types'

const Agency = (props: { agency: AgencyModel }) => {
  const { agency, agency: { address_region, id, title } } = props

  const { editAgencyRelationsUrl } = generateUrls(agency)

  const agencyRelations = useRelations(agency)
  const { brand } = agencyRelations

  return (
    <DashboardModuleListItem
      href={`${editAgencyRelationsUrl}?redirect=${generateRedirectUrl()}`}
      secondaryText={brand.title}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`${address_region || ''} # ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default Agency
